import { FormControl } from "react-bootstrap";

const RequiredItem = ({ condition, message = 'Veuillez remplir le champ' }) => {
    return ( 
        <div>
            <FormControl type='text' style={{display: 'none'}} value={condition ? '.' : ''} onChange={()=>{}} required></FormControl>
            <FormControl.Feedback type="invalid">{message}</FormControl.Feedback>
        </div>
     );
}
 
export default RequiredItem;